module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/cap-2-2e5819d6dcc2092bb185c4c2436f275c.svg";